/* Turns the migrated product markers in article bodies into buyable cards. */
(function () {
  var MONEY = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  function card(p, node) {
    var available = p.variants.filter(function (v) { return v.available; });
    var buyable = available.length > 0;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var wrap = document.createElement('div');
    wrap.className = 'iss-prod';

    var opts = '';
    if (p.variants.length > 1) {
      opts = '<select name="id" class="iss-prod__variants" aria-label="Choose an option">' +
        p.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
            v.title + ' &middot; ' + MONEY(v.price) + (v.available ? '' : ' (sold out)') + '</option>';
        }).join('') + '</select>';
    } else {
      opts = '<input type="hidden" name="id" value="' + p.variants[0].id + '">';
    }

    wrap.innerHTML =
      '<a class="iss-prod__media" href="/products/' + p.handle + '">' +
        (img ? '<img src="' + img.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') + '" alt="" loading="lazy" width="120" height="120">' : '') +
      '</a>' +
      '<div class="iss-prod__body">' +
        '<a class="iss-prod__title" href="/products/' + p.handle + '">' + p.title + '</a>' +
        '<p class="iss-prod__price">' + MONEY(p.price) + '</p>' +
        (buyable
          ? '<form class="iss-prod__form" action="/cart/add" method="post" enctype="multipart/form-data">' +
              opts +
              '<button type="submit" class="iss-prod__btn">Add to cart</button>' +
            '</form>'
          : '<p class="iss-prod__sold">Currently unavailable</p>' +
            '<a class="iss-prod__link" href="/products/' + p.handle + '">View product</a>') +
      '</div>';

    node.parentNode.replaceChild(wrap, node);
  }

  function hydrate() {
    var nodes = document.querySelectorAll('.iss-post-product');
    Array.prototype.forEach.call(nodes, function (node) {
      var a = node.querySelector('a[href*="/products/"]');
      if (!a) { node.remove(); return; }              // unlinked leftovers
      var handle = a.getAttribute('href').split('/products/')[1];
      if (!handle) return;
      handle = handle.split(/[?#]/)[0];
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (p) { card(p, node); })
        .catch(function () { /* leave the plain link in place */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
